var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarSolid = function SvgCalendarSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.958008 10.6666H23.0413C23.3851 10.6666 23.6663 10.9479 23.6663 11.2916V24.8333C23.6663 26.2135 22.5465 27.3333 21.1663 27.3333H2.83301C1.4528 27.3333 0.333008 26.2135 0.333008 24.8333V11.2916C0.333008 10.9479 0.614258 10.6666 0.958008 10.6666ZM23.6663 8.37496V6.49996C23.6663 5.11975 22.5465 3.99996 21.1663 3.99996H18.6663V1.29163C18.6663 0.947876 18.3851 0.666626 18.0413 0.666626H15.958C15.6143 0.666626 15.333 0.947876 15.333 1.29163V3.99996H8.66634V1.29163C8.66634 0.947876 8.38509 0.666626 8.04134 0.666626H5.95801C5.61426 0.666626 5.33301 0.947876 5.33301 1.29163V3.99996H2.83301C1.4528 3.99996 0.333008 5.11975 0.333008 6.49996V8.37496C0.333008 8.71871 0.614258 8.99996 0.958008 8.99996H23.0413C23.3851 8.99996 23.6663 8.71871 23.6663 8.37496Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_solid.cbcdc7f0.svg";
export { ForwardRef as ReactComponent };